module.exports = __webpack_public_path__ + "img/partner-google@2x.f370c0f5.png";